<template>
  <div class="my-5" :class="col ? `col-lg-${col}` : ''">
    <!-- :class="{ disabled_input: disabled }" -->
    <div class="input_wrapper top_label select_wrapper" ref="selectWrapper">
      <label class="form-label" v-if="placeholder">
        {{ placeholder }}
        <span class="text-danger" v-if="required">*</span>
      </label>
      <multiselect
        ref="multiselect"
        :options="optionsList"
        :label="label"
        :track-by="trackBy"
        placeholder=" "
        :searchable="true"
        :allow-empty="true"
        :show-labels="false"
        :open-direction="'bottom'"
        reduce=""
        :value="value"
        @input="
          updateValue($event);
          $emit('fireInputEvent');
        "
        @open="onDropdownOpen"
        @close="onDropdownClose"
        :multiple="multiple"
        :readonly="readonly"
        :disabled="disabled"
        :close-on-select="focus"
        v-bind="$attrs"
        v-on="$listeners"
      >
      </multiselect>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "BaseSelectInput",
  emits: ["fireInputEvent", "loadMore"],
  props: {
    // ====== Start:: General Inputs Props ====== //
    col: {
      required: false,
      type: String,
    },
    optionsList: {
      required: true,
    },
    label: {
      type: String,
      default: "name",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      type: String,
    },
    multiple: {
      required: false,
      type: Boolean,
      default: false,
    },
    trackBy: {
      required: false,
      type: String,
      default: "id",
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    focus: {
      required: false,
      type: Boolean,
      default: true,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    hasMore: {
      required: false,
      type: Boolean,
      default: false,
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false,
    },
    // ====== End:: General Inputs Props ====== //
  },
  data() {
    return {
      isScrolling: false,
      scrollListener: null,
    };
  },
  methods: {
    updateValue(e) {
      console.log("change", e);

      this.$emit("input", e);
    },
    onDropdownOpen() {
      // Setup scroll event listener when dropdown opens
      this.$nextTick(() => {
        const dropdownMenu = this.$el.querySelector(
          ".multiselect__content-wrapper"
        );
        if (dropdownMenu) {
          // Create a bound scroll handler
          this.scrollListener = this.handleMultiselectScroll.bind(this);
          dropdownMenu.addEventListener("scroll", this.scrollListener);
          console.log("Scroll listener attached");
        }
      });
    },
    onDropdownClose() {
      // Remove scroll event listener when dropdown closes
      const dropdownMenu = this.$el.querySelector(
        ".multiselect__content-wrapper"
      );
      if (dropdownMenu && this.scrollListener) {
        dropdownMenu.removeEventListener("scroll", this.scrollListener);
        this.scrollListener = null;
        console.log("Scroll listener removed");
      }
    },
    handleMultiselectScroll() {
      const dropdownMenu = this.$el.querySelector(
        ".multiselect__content-wrapper"
      );
      if (!dropdownMenu) return;

      // Check if scrolled near bottom (within 100px)
      const scrollPosition = dropdownMenu.scrollTop + dropdownMenu.clientHeight;
      const scrollHeight = dropdownMenu.scrollHeight;

      console.log(
        `Scroll: ${scrollPosition}/${scrollHeight}, hasMore: ${this.hasMore}, loading: ${this.isLoading}`
      );

      if (
        scrollHeight - scrollPosition < 100 &&
        !this.isScrolling &&
        this.hasMore &&
        !this.isLoading
      ) {
        console.log("Triggering loadMore");
        this.isScrolling = true;
        this.$emit("loadMore");
        setTimeout(() => {
          this.isScrolling = false;
        }, 500);
      }
    },
  },
  beforeDestroy() {
    // Cleanup event listener
    const dropdownMenu = this.$el?.querySelector(
      ".multiselect__content-wrapper"
    );
    if (dropdownMenu && this.scrollListener) {
      dropdownMenu.removeEventListener("scroll", this.scrollListener);
    }
  },
};
</script>
